import React, { useEffect, useState } from "react";
import {
  CustomerAddressRow,
  SideBackNav,
  OrderItems,
} from "../../../../components/organisms";
import { NewOrderDetailRow } from "./NewOrderDetailRow";
import { useLocation } from "react-router";
import { UPDATENEWORDERFLAG } from "../../../../api/apiConfig";
import actions from "../../../../store/actions";
import { useDispatch } from "react-redux";
import { apiPost, getOrderItems } from "../../../../utils";
import { useMediaQuery } from "react-responsive";

export const OrderDetailsComp = ({ onBack }) => {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 900px)' })
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const { state } = useLocation();
  const {
    customer,
    time,
    date,
    orderNumber,
    url,
    value,
    customerAddress,
    isNewOrder,
    orderId,
    note,
    lineItems
  } = state || {};
  const orderValue = value.toFixed(2);
  
  useEffect(async () => {
    updateOrderFlag();
    setIsLoading(true);
    //const { itemsAndLinks: res } = await getOrderItems(orderId);

    setData(lineItems);
    setIsLoading(false);
  }, []);

  const updateOrderFlag = async () => {
    if (isNewOrder) {
      const res = await apiPost(UPDATENEWORDERFLAG, { orderId });
      if (res && res.success) {
        dispatch(actions.decrementNumOfNewOrders());
      }
    }
  };

  return (
    <div className="new-orders-screen">
      <div className="dashboard-content-post body" style={{marginLeft:'0px'}}>
        <SideBackNav
          title={"Back"}
          title2={isTabletOrMobile &&`Order ${orderNumber}`}
          onClick={onBack}
          orderNumber={`Order ${orderNumber}`}
          statusTitle={"New Order"}
          ifNotes
          notes={note}
          isView={note ? true : false}
        />
      </div>
      <div className="details-overlay">
        <div className="new-orders-container" id="details-screen-box">
          <div className="orders">
            <NewOrderDetailRow
              customerName={customer || "N/A"}
              time={time}
              orderDate={date}
              orderValue={orderValue}
              productUrl={url}
              orderRef={orderNumber}
            />
          </div>
        </div>
        <div className="top-space-details">
          <div className="new-orders-container" id="details-screen-box">
            <div className="orders">
              <CustomerAddressRow
                customerContactNo={customerAddress?.phone || "N/A"}
                address1={customerAddress?.address1 || "N/A"}
                address2={customerAddress?.address2 || "N/A"}
                postalCode={customerAddress?.zip || "N/A"}
                city={customerAddress?.city || "N/A"}
                country={customerAddress?.country || "N/A"}
              />
            </div>
          </div>
        </div>
        <OrderItems data={data} isLoading={isLoading} />
      </div>
    
    </div>
  );
};
